import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import {
  locationMapPoco,
  locationMapBurnaby,
  mobileMapPoco,
  mobileMapBurnaby,
} from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => {
        let locationLink = ''
        let mapImageMobile = null
        let mapImage = null
        if (locationId === 'OYbBwTgZhsMcWjZraBug') {
          locationLink = 'https://goo.gl/maps/EA5SQHS5WDBsqDx99'
          mapImage = locationMapBurnaby
          mapImageMobile = mobileMapBurnaby
        } else {
          locationLink = 'https://g.page/sushionpoco?share'
          mapImage = locationMapPoco
          mapImageMobile = mobileMapPoco
        }
        return (
          <CFView>
            <MobileScreen>
              <CFLink href={locationLink} target="_blank">
                <CFImage src={mapImageMobile} w="100%" alt="Sushi On Map" />
              </CFLink>
            </MobileScreen>
            <DefaultScreen>
              <CFLink href={locationLink} target="_blank">
                <CFImage src={mapImage} w="100%" alt="Sushi On Map" />
              </CFLink>
            </DefaultScreen>
          </CFView>
        )
      }}
    </CFSelect>
  )
}
